module.exports = __webpack_public_path__ + "img/SKMJ_mesh1.756e4120.jpg";